import { useRemoteConfig } from '@funtech-int/yango-shared';

const DEFAULT_HEADER_ITEMS = [] as string[];

export function useHeaderItems(): string[] {
    const remoteConfig = useRemoteConfig();

    return (remoteConfig.flags.get('header_items') as string[] | undefined) ?? DEFAULT_HEADER_ITEMS;
}
